module.exports = __webpack_public_path__ + "static/media/blur.44c5bb3e.svg";